import React, { createRef } from 'react';
import Slido from "./Slido";

export default class Chat extends Slido {
    constructor() {
        super();
        this.chatContainerRef = createRef();
        this.messageBlockRef = createRef();
        this.newMessageRef = createRef();
        this.minHeight = 550;
    }

    render() {
        const { isEnabled, sendBtnText } = this.props;

        if (Number(isEnabled) !== 1 || sendBtnText === '') {
            return null;
        }

        return (
            <div
                id="ChatContainer"
                ref={this.chatContainerRef}
                style={{
                    transitionProperty: "all",
                    transitionDuration: "1.5s"
                }}
                title="Chat"
            >
                <div id="message-block" ref={this.messageBlockRef}>
                    <div id="chat-messages">
                        <table cellPadding="0" cellSpacing="0">
                            <tbody id="chat-table"></tbody>
                        </table>
                    </div>
                </div>

                <div id="new-message" ref={this.newMessageRef}>
                    <textarea
                        id="user-message"
                        onKeyUp={(event) => { chat.keyUpFunc(event); }}
                    />
                    <input
                        type="button"
                        id="send-btn"
                        onClick={() => { chat.send(); }}
                        value={sendBtnText}
                    />
                </div>
            </div>
        );
    }
}
